{
  "auth.email_signup.email.label": "E-mail",
  "auth.email_signup.first_name_caption": "Você pode adicionar um nome preferido na sua Conta mais tarde.",
  "auth.email_signup.first_name_on_driver_license.label": "Primeiro nome na carteira de motorista",
  "auth.email_signup.firstname.required": "O nome é obrigatório",
  "auth.email_signup.last_name_on_driver_license.label": "Sobrenome na carteira de motorista",
  "auth.email_signup.lastname.required": "O sobrenome é obrigatório",
  "auth.email_signup.marketing.label": "Quero receber promoções e novidades por e-mail",
  "auth.email_signup.marketing.optin_matrix_label": "Envie-me atualizações, recomendações e ofertas por e-mail",
  "auth.email_signup.sms_marketing.label": "Quero receber promoções e novidades por SMS",
  "auth.email_signup.or_sign_up_with_others": "Ou cadastre-se com {#facebookLink}Facebook{/facebookLink} ou {#googleLink}Google{/googleLink}",
  "auth.email_signup.password.error_min_length": "A senha deve ter pelo menos 8 caracteres",
  "auth.email_signup.email.error_format": "Insira um e-mail válido",
  "auth.email_signup.password.label": "Senha",
  "auth.email_signup.sign_up": "Criar conta",
  "auth.email_signup.terms_of_service.label": "Concordo com os {#termsOfServiceLink}termos de serviço{/termsOfServiceLink} e a {#privacyPolicyLink}política de privacidade{/privacyPolicyLink}.",
  "auth.email_signup.title": "Vamos começar"
}
